module.exports = __webpack_public_path__ + "img/360.2becc250.svg";